import useNotificationReadMutation from "../../hooks/useNotificationReadMutation";
import { NotificationItem } from "./NotificationItem";
import { Notification } from "../../notifications.types";

export type Props = {
  notification: Notification;
  isRefetching: boolean;
  isExpanded: boolean;
  isAnyExpanded: boolean;
  onExpand: (notificationId: number) => void;
  onCollapse: (notificationId: number) => void;
};

export function NotificationItemContainer({
  notification,
  isRefetching,
  isExpanded,
  isAnyExpanded,
  onExpand,
  onCollapse,
}: Props) {
  const { mutate: markAsRead } = useNotificationReadMutation();

  return (
    <NotificationItem
      notification={notification}
      onMarkAsRead={markAsRead}
      isRefetching={isRefetching}
      isExpanded={isExpanded}
      isAnyExpanded={isAnyExpanded}
      onExpand={onExpand}
      onCollapse={onCollapse}
    />
  );
}

export default NotificationItemContainer;
